import { useDispatch } from 'react-redux'
import { reopenOrder, retotalOrder } from '../Apis'
import { ToastManager } from '../../utils/toastManager'
import { orderDetailsRequested, tabReopenFailed, tabReopenRequested, tabReopenSucceeded } from '../../actions/order'
import { setReopenedTabPayments } from '../../VNTenders/ActionCreators'
import { ORDER_STATES } from '../../utils/orderStates'

/**
 * Hook for handling reopening a tab
 *
 * @returns
 */
const useReopenTab = () => {
  const dispatch = useDispatch()

  const reopenTab = async (order) => {
    const orderUuid = order?.uuid
    const reopenState = order?.wasCreatedInStadium ? ORDER_STATES.TABBED : ORDER_STATES.TABBED_OFFLINE
    const balanceDueInCents = order?.amountInCents
    const cashRounded = order?.cashRounded

    try {
      dispatch(tabReopenRequested())

      //reopen order in stadium
      await reopenOrder(orderUuid)

      //update order to reflect changes in local state
      dispatch(tabReopenSucceeded({ orderUuid, reopenState, balanceDueInCents }))

      //retotal order in stadium
      await retotalOrder(orderUuid, order.promotions)

      //get updated values from stadium
      dispatch(orderDetailsRequested(orderUuid))

      const successMessage = cashRounded ? 'Success! Tab reopened and rounding removed.' : 'Success! Tab reopened.'
      ToastManager.success(successMessage)
    } catch (error) {
      dispatch(tabReopenFailed({ orderUuid }))
      ToastManager.error(error?.message || 'Failed to reopen tab', { autoClose: false })
    }
  }

  const reopenOfflineTab = async (order) => {
    const orderUuid = order?.uuid
    const reopenState = ORDER_STATES.TABBED
    const balanceDueInCents = order?.amountInCents

    try {
      dispatch(tabReopenRequested())
      //store CC payments in local state
      dispatch(setReopenedTabPayments({ orderUuid, payments: order.payments }))
      //update order to reflect changes in local state
      dispatch(tabReopenSucceeded({ orderUuid, reopenState, balanceDueInCents }))

      ToastManager.success('Success! Tab reopened.')
    } catch (error) {
      dispatch(tabReopenFailed({ orderUuid }))
      ToastManager.error(error?.message || 'Failed to reopen tab', { autoClose: false })
    }
  }
  return {
    reopenTab,
    reopenOfflineTab,
  }
}

export default useReopenTab
